module.exports = __webpack_public_path__ + "img/cluna.5481b9b8.jpg";